import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaComponent } from './media/media.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipeModule, MMIconsModule, AlertModule } from 'mm-ui';



@NgModule({
  declarations: [MediaComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    SafePipeModule,
    MMIconsModule,
    AlertModule,
  ], exports: [MediaComponent]
})
export class MediaViewModule { }
